
import fetch from '../../fetch';

const queryCharts = (data) => {
    return fetch.post('surveyteacheranalysis/sub/analysis', data)
        .then(response => {
            if(response.code == 200) {
                // return {
                //     dataSource: response.payload.data,
                //     max: response.payload.meta.extParams.maxValue,
                //     min: response.payload.meta.extParams.minValue
                // }
                return response.payload.data
            }
        })
}


export default {
    queryCharts,
}